/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {TableLineModel} from '../../../shared/table/models/table-line.model';
import {TableModel} from '../../../shared/table/models/table.model';
import scrollIntoViewOptions from './configuration/info-chart-configuration';

export function scrollIntoView(identifier: string): void {
    const elementToScroll = document.getElementById(`${identifier}`);
    elementToScroll?.scrollIntoView(scrollIntoViewOptions);
}

export function openLine<T, V>(tableData: TableModel<T, V>,
                               lineIdentifier: string,
                               isFromChart?: boolean
): TableLineModel<T, V> {

    const line: TableLineModel<T, V> = tableData.staticSection?.find(
            (item) => item.identifier === `${lineIdentifier}`);

    if (line != null && line.identifier != null) {
        const lineStatus: boolean = line.isOpen;
        tableData.staticSection.forEach((item) => item.isOpen = false);
        line.isOpen = isFromChart ? !lineStatus : true;
        return line;
    }
}
